import PageWrapper from "@/components/layout/page-wrapper";
import ChatTypeHeader from "@/components/conversations/chat-type-header/chat-type-header";
import ChatUserList from "@/components/conversations/chat-user-list/chat-user-list";
import ConversationHistory from "@/components/conversations/conversation-history/conversation-history";
import { useSearchParams } from "react-router";
import AgentChatParent from "@/components/conversations/agent-chat-parent/agent-chat-parent";

const Conversations = () => {
    const [searchParams] = useSearchParams();

    return (
        <PageWrapper pageTitle="Conversations" currentPage="Conversations">
            <>
                <ChatTypeHeader />
            </>

            {searchParams.get("type") === "agent-chat" ? (
                <AgentChatParent />
            ) : (
                <div className="mt-4 grid grid-cols-4 gap-4">
                    <>
                        <ChatUserList className="col-span-4 lg:col-span-1" />
                    </>
                    <div className="col-span-4 lg:col-span-3">
                        <>
                            <ConversationHistory />
                        </>
                    </div>
                </div>
            )}
        </PageWrapper>
    );
};

export default Conversations;
